import configData from '../../config.json';
import axios from 'axios';
import { Decrypt } from '../Helper';

export const GetNotification = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `notifications/getWinnerByStudentId`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetNotificationCertificate = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `challengewinner/getStudentChallengesDetailsById`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const GetAdminNotification = async (v) => {
    var config = {
        method: 'post',
        url: configData.API_ENDPOINT + `notifications/admin`,
        headers: {
            Authorization: 'Bearer ' + Decrypt(sessionStorage.getItem('token')),
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}
